export const CAP_LEVELS = [
    {
        key: "NONE",
        name: "None",
        color: '#666',
        colorSubtle: '#AAA'

    },
    {
        key: "LIGHT_BLUE",
        name: "Light Blue",
        color: '#62B5E5',
        colorSubtle: '#62B5E544'
    },
    {
        key: "BLUE",
        name: "Blue",
        color: '#0058B7',
        colorSubtle: '#0058B744'
    },
    {
        key: "GREEN",
        name: "Green",
        color: '#00B140',
        colorSubtle: '#00B14044'

    },
    {
        key: "LIME",
        name: "Lime",
        color: '#97D700',
        colorSubtle: '#97D70044'
    },
    {
        key: "YELLOW",
        name: "Yellow",
        color: '#FED241',
        colorSubtle: '#FED24144'
    },
    {
        key: "ORANGE",
        name: "Orange",
        color: '#FF6900',
        colorSubtle: '#FF690044'
    }
];
